import { SVGProps } from "react";

export function SparklesIllustration(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={88} height={88} viewBox="0 0 88 88" fill="none" {...props}>
      <circle opacity={0.2} cx={44} cy={44} r={32} fill="#DEDFE0" />
      <rect x={22} y={36} width={44} height={16} rx={2} fill="#3E8D96" />
      <rect
        opacity={0.9}
        x={26}
        y={40}
        width={22}
        height={3}
        rx={1.5}
        fill="white"
      />
      <rect
        opacity={0.6}
        x={26}
        y={45}
        width={36}
        height={3}
        rx={1.5}
        fill="white"
      />
      <path
        d="M24.0433 11.1431C24.331 10.198 25.669 10.198 25.9567 11.1431L27.6449 16.6897C27.7419 17.0085 27.9915 17.2581 28.3103 17.3551L33.8569 19.0433C34.802 19.331 34.802 20.669 33.8569 20.9567L28.3103 22.6449C27.9915 22.7419 27.7419 22.9915 27.6449 23.3103L25.9567 28.8569C25.669 29.802 24.331 29.802 24.0433 28.8569L22.3551 23.3103C22.2581 22.9915 22.0085 22.7419 21.6897 22.6449L16.1431 20.9567C15.198 20.669 15.198 19.331 16.1431 19.0433L21.6897 17.3551C22.0085 17.2581 22.2581 17.0085 22.3551 16.6897L24.0433 11.1431Z"
        fill="#AACFD3"
      />
      <path
        d="M61.0433 63.1431C61.331 62.198 62.669 62.198 62.9567 63.1431L63.7115 65.623C63.8085 65.9419 64.0581 66.1915 64.377 66.2885L66.8569 67.0433C67.802 67.331 67.802 68.669 66.8569 68.9567L64.377 69.7115C64.0581 69.8085 63.8085 70.0581 63.7115 70.377L62.9567 72.8569C62.669 73.802 61.331 73.802 61.0433 72.8569L60.2885 70.377C60.1915 70.0581 59.9419 69.8085 59.623 69.7115L57.1431 68.9567C56.198 68.669 56.198 67.331 57.1431 67.0433L59.623 66.2885C59.9419 66.1915 60.1915 65.9419 60.2885 65.623L61.0433 63.1431Z"
        fill="#AACFD3"
      />
      <path
        d="M49.0433 23.1431C49.331 22.198 50.669 22.198 50.9567 23.1431L51.2448 24.0897C51.3418 24.4086 51.5914 24.6582 51.9103 24.7552L52.8569 25.0433C53.802 25.331 53.802 26.669 52.8569 26.9567L51.9103 27.2448C51.5914 27.3418 51.3418 27.5914 51.2448 27.9103L50.9567 28.8569C50.669 29.802 49.331 29.802 49.0433 28.8569L48.7552 27.9103C48.6582 27.5914 48.4086 27.3418 48.0897 27.2448L47.1431 26.9567C46.198 26.669 46.198 25.331 47.1431 25.0433L48.0897 24.7552C48.4086 24.6582 48.6582 24.4086 48.7552 24.0897L49.0433 23.1431Z"
        fill="#AACFD3"
      />
    </svg>
  );
}
